import axios from './plugins/axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './assets/scss/index.scss'
import { checkI18n } from './plugins/i18n'
import { Tools } from './plugins/tools'

const app = createApp(App)

app.config.globalProperties.$axios = axios
app.config.globalProperties.$checkI18n = checkI18n
app.config.globalProperties.$tools = Tools

app.use(i18n).use(store).use(router).mount('#app')
